import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_dashboard/dashboard/quotes/request/$requestId')({
  params: z.object({ requestId: z.string() })
});

export const useQuoteRequestParams = () => Route.useParams();
